import { Button } from "@/components/ui/button";

interface ConvertButtonProps {
  onClick: () => void;
}

export function ConvertButton({ onClick }: ConvertButtonProps) {
  return (
    <div className="flex justify-center">
      <Button
        onClick={onClick}
        className="bg-manuscript-primary text-white hover:bg-manuscript-primary/90"
      >
        Convert
      </Button>
    </div>
  );
}